import React from "react";
import { components } from "react-select";
import { LARGE_SCREEN } from "@streeteasy/design-system/constants/screenSizes";
import colors from "@streeteasy/design-system/deprecated/colors";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";
import ClearIcon from "@streeteasy/design-system/deprecated/Icons/SVG/ClearIcon";
import XIcon from "@streeteasy/design-system/deprecated/Icons/SVG/XIcon";

const font = "400 14px/18px 'Source Sans Pro', sans-serif";

export const componentOverrides = {
  ClearIndicator: componentProps => (
    <components.ClearIndicator {...componentProps}>
      <ClearIcon width="15px" />
    </components.ClearIndicator>
  ),
  DropdownIndicator: componentProps => (
    <components.DropdownIndicator {...componentProps}>
      <FontAwesomeIcon
        color="inherit"
        desktopPadding="0"
        iconClass="angleDown"
      />
    </components.DropdownIndicator>
  ),
  Input: componentProps => (
    <components.Input
      {...componentProps}
      onKeyDown={event => {
        if (
          (event.key === "Escape" || event.key === "Esc") &&
          componentProps.selectProps.menuIsOpen
        ) {
          event.nativeEvent.stopImmediatePropagation();
        }
      }}
    />
  ),
  MultiValueRemove: componentProps => (
    <components.MultiValueRemove {...componentProps}>
      <XIcon color={colors.whaleGrey} width="7px" />
    </components.MultiValueRemove>
  )
};

export const styleOverrides = {
  clearIndicator: styles => ({
    ...styles,
    color: colors.foxGrey,
    cursor: "pointer",
    ":hover": {
      color: colors.foxGrey
    },
    paddingLeft: "15px",
    paddingRight: "15px"
  }),
  container: styles => ({
    ...styles,
    font
  }),
  control: styles => ({
    ...styles,
    border: `1px solid ${colors.foxGrey}`,
    borderRadius: "none"
  }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    color: colors.koalaGrey,
    cursor: "pointer",
    paddingLeft: "15px",
    paddingRight: "15px",
    transform: `rotate(${state.selectProps.menuIsOpen ? "180deg" : "0"})`
  }),
  indicatorSeparator: styles => ({
    ...styles,
    backgroundColor: colors.rabbitGrey,
    margin: "11px 0"
  }),
  input: styles => ({
    ...styles,
    input: {
      font
    },
    [`@media screen and (max-width: ${LARGE_SCREEN}px)`]: {
      fontSize: "16px",
      lineHeight: "24px"
    }
  }),
  menu: styles => ({
    ...styles,
    borderBottom: `1px solid ${colors.foxGrey}`,
    borderLeft: `1px solid ${colors.foxGrey}`,
    borderRight: `1px solid ${colors.foxGrey}`,
    borderRadius: "0",
    boxShadow: "1px 3px 4px 0 rgba(0, 0, 0, 0.1)",
    marginTop: "0"
  }),
  menuList: styles => ({ ...styles, padding: "15px 0" }),
  multiValue: styles => ({
    ...styles,
    backgroundColor: colors.glass,
    borderRadius: "14px"
  }),
  multiValueLabel: styles => ({
    ...styles,
    // paddings are defined separately because react-select
    // has a paddingLeft defined, so that particular style needs
    // to be defined here to take precedence
    paddingBottom: "6px",
    paddingLeft: "15px",
    paddingRight: "5px",
    paddingTop: "4px",
    font
  }),
  multiValueRemove: styles => ({
    ...styles,
    cursor: "pointer",
    paddingLeft: "3px",
    paddingRight: "15px",
    ":hover": {
      backgroundColor: "transparent"
    }
  }),
  option: (styles, state) => {
    let backgroundColor = "white";
    if (state.isSelected) {
      backgroundColor = colors.rabbitGrey;
    } else if (state.isFocused) {
      backgroundColor = colors.mouseGrey;
    }

    return {
      ...styles,
      backgroundColor,
      color: colors.whaleGrey,
      padding: "6px 15px",
      ":active": {
        ...styles[":active"],
        backgroundColor: colors.rabbitGrey
      },
      [`@media screen and (max-width: ${LARGE_SCREEN}px)`]: {
        fontSize: "16px",
        lineHeight: "24px"
      }
    };
  },
  placeholder: styles => ({
    ...styles,
    color: colors.koalaGrey,
    [`@media screen and (max-width: ${LARGE_SCREEN}px)`]: {
      fontSize: "16px",
      lineHeight: "24px"
    }
  }),
  valueContainer: styles => ({
    ...styles,
    color: colors.whaleGrey,
    paddingLeft: "13px",
    [`@media screen and (max-width: ${LARGE_SCREEN}px)`]: {
      fontSize: "16px",
      lineHeight: "24px"
    }
  })
};
